import type { FeatureModule } from '@/app/contract';
import { registerNamespace } from '@/i18n';
import en from './locales/en.json';
import zh from './locales/zh-Hans.json';

registerNamespace('composer', { en, 'zh-Hans': zh });

/** Embedded by Chat; this feature owns no route or global shortcut. */
const feature: FeatureModule = { id: 'composer', routes: [], commands: [] };

export default feature;

export { Composer, type ComposerProps } from './public';
